// src/Api/constants.js


// export let MainUrl = "http://localhost:7001";
// export let MainUrl = window.Config?.Server?.Domain || "http://localhost:7001";
export let MainUrl = window.Config?.Server?.Domain || "https://nova-api.futuresolutionsdev.com";
export let ApiVersion = window.Config?.Server?.Path || "/api/v1";
export let Ws = window.Config?.Server?.SocketPath || "/v1/ws";
export let BASE_API_URL = `${MainUrl}${ApiVersion}/`;
export let WAFEQ_API_URL = null;
export let WAFEQ_API_KEY = null;
export let TIPS_INTERVAL = 3_000;
export const setWafeqCredentials = (accessArray) => {
  const wafeqAccess = accessArray?.find(item => item.Provider === "Wafeq");
  if (wafeqAccess) {
    // Route through our backend proxy to avoid CORS in production.
    // The server fetches the API key from DB and forwards to api.wafeq.com.
    // WAFEQ_API_URL = `${BASE_API_URL}wafeq/`;
    WAFEQ_API_URL = `${BASE_API_URL}wafeq/`;
    WAFEQ_API_KEY = null;
  } else {
    WAFEQ_API_URL = null;
    WAFEQ_API_KEY = null;
  }
};

export const hasWafeqAccess = () => {
  return !!WAFEQ_API_URL;
};